import { baseStationStates, firmwareStateMap } from "./constants";

export function getStatus(status) {
  if (["Accepted", "NtripAccepted", "NtripStarted"].includes(status)) {
    return "Connected";
  } else if (["NtripEnded", "Terminated"].includes(status)) {
    return "Disconnected";
  } else if (["authorized"].includes(status)) {
    return "Authorized";
  }
  return null;
}

export function monitoringStatusClass(value, commons) {
  let conditions = {
    "notActive": "red-light5--bg",
    "active": "green-light5--bg",
    "loading...": "grey-light3--bg",
    "authorized": "amber-light3--bg",
    "assumedIdle": "lime-light3--bg",
  }
  let ifnull = "grey-light3--bg"
  return conditionalClass(conditions, value, commons, ifnull)
}

export function robotStatusClass(value, commons) {
  let conditions = {
    Disconnected: "red-light5--bg",
    Connected:    "green-light3--bg",
    Authorized:   "amber-light3--bg",
  }
  let ifnull = "grey-light3--bg"
  return conditionalClass(conditions, value, commons, ifnull)
}

function conditionalClass(_conditionsMap, _var, _class_common, _class_null) {
  let commons = _class_common ? (" " + _class_common) : "";
  if (
    _conditionsMap &&
    _conditionsMap instanceof Object &&
    _conditionsMap[_var]
  ) {
    return _conditionsMap[_var] + commons;
  } else if (_class_null) {
    return _class_null + commons;
  }
  return "";
}

export function statusinfo(baseStationStates) {
  let info = {};
  Object.keys(baseStationStates).forEach(key => {
    let state = baseStationStates[key];
    info[state] = { id: state, name: state, class: monitoringStatusClass(state), info: "" }
  });
  return info;
}

export function statusInfoBaseStation() {
  let info = setBaseStationStateInfos()
  return [info[baseStationStates.active], info[baseStationStates.notActive], info[baseStationStates.authorized], info[baseStationStates.idle]];
}

export function setBaseStationStateInfos() {
  let info = statusinfo(baseStationStates)
  info[baseStationStates.active].info = "The base station is currently connected to an NTRIP caster and has an ongoing NTRIP connection. Rovers can discover it and receive RTK corrections from it.";
  info[baseStationStates.notActive].info = "The base station in not currently connected to any NTRIP caster. Rovers cannot discover it and cannot use it. However the base station has been active at least once in the recent past.";
  info[baseStationStates.notActive].name = "not active"
  info[baseStationStates.authorized].info = "The base station has been provisioned but has not connected to any caster in the recent past. The base station is then not available to rovers."
  info[baseStationStates.authorized].name = "authorized"
  info[baseStationStates.idle].info = "The base station is in a standby state, and its coverage may be available upon waking up."
  info[baseStationStates.idle].name = "idle"
  return info;
}

export function getInfoByState(state) {
  let info = setBaseStationStateInfos()
  return info[state] || { id: state, name: 'unknown', class: 'grey-light3--bg', info: '' }
}

export function statusInfoNtripExtended() {
  let base = statusInfoBaseStation();
  return [
    ...base,
    { id: baseStationStates.new, name: "new antenna", class: "blue-light3--bg", info: "Antenna never georeferenced, no coverage circle shown on map." },
  ];
}

export function statusInfoGeoref() {
  return [
    { id: "GEOREFERENCED",         name: "georeferenced",   class: "green-light5--bg",  info: "The antenna has valid ECEF coordinates and a georeferencing history. Its position on the map is confirmed and stable." },
    { id: "NOT_YET_GEOREFERENCED", name: "not yet georef.", class: "orange-light3--bg", info: "The antenna has ECEF coordinates but no georeferencing history yet. The position is known but has not been formally validated." },
    { id: "NEW_ANTENNA",           name: "new antenna",     class: "blue-light3--bg",   info: "The antenna has no ECEF coordinates and no georeferencing history. It has been provisioned but never physically positioned." },
    { id: "GEOREFERENCING",        name: "georeferencing",  class: "purple-light3--bg", info: "A georeferencing task is currently open and in progress on this antenna." },
    { id: "UNEXPECTED",            name: "unexpected",      class: "red-light5--bg",    info: "The antenna has no ECEF coordinates but a georeferencing history exists. This is an anomalous state that may require investigation." },
  ];
}

export function getInfoByGeorefState(state) {
  const found = statusInfoGeoref().find(s => s.id === state)
  return found || { id: state, name: 'unknown', class: 'grey-light3--bg', info: '' }
}

export function statusInfoFirmware() {
  return [
    { id: 'SETTLED',              name: firmwareStateMap.SETTLED.label,              class: firmwareStateMap.SETTLED.class,              info: 'Firmware is up to date.' },
    { id: 'OUTDATED',             name: firmwareStateMap.OUTDATED.label,             class: firmwareStateMap.OUTDATED.class,             info: 'Firmware version is outdated and may need an update.' },
    { id: 'TEST_DEVICE',          name: firmwareStateMap.TEST_DEVICE.label,          class: firmwareStateMap.TEST_DEVICE.class,          info: 'Device is tagged as a test device, automatic updates disabled.' },
    { id: 'UNKNOWN',              name: firmwareStateMap.UNKNOWN.label,              class: firmwareStateMap.UNKNOWN.class,              info: 'Firmware version could not be determined (unsuccessful response).' },
    { id: 'NOT_FOUND',            name: firmwareStateMap.NOT_FOUND.label,            class: firmwareStateMap.NOT_FOUND.class,            info: 'Device not found in firmware registry.' },
    { id: 'ERROR',                name: firmwareStateMap.ERROR.label,                class: firmwareStateMap.ERROR.class,                info: 'An error occurred while retrieving firmware status.' },
    { id: 'AUTO_UPDATE_DISABLED', name: firmwareStateMap.AUTO_UPDATE_DISABLED.label, class: firmwareStateMap.AUTO_UPDATE_DISABLED.class, info: 'Automatic firmware update is disabled for this device.' },
  ];
}

export function getInfoByFirmwareState(state) {
  if (state == null) return null
  const found = statusInfoFirmware().find(s => s.id === state)
  return found || { id: state, name: state.toLowerCase(), class: 'grey-light3--bg', info: '' }
}

export function statusInfoMapLegend() {
  return [
    { id: "section-ntrip",  name: "NTRIP Connection", class: "text-bold", info: "" },
    ...statusInfoNtripExtended(),
    { id: "section-georef", name: "Georeferencing",   class: "text-bold", info: "" },
    ...statusInfoGeoref(),
  ];
}
